import React from 'react';

import { Modal } from '@/components/Modal';
import { CustomerTypeValue } from '@/types';

interface CustomerTypeChangeConfirmationDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  currentType: CustomerTypeValue | null;
  newType: CustomerTypeValue;
}

export const CustomerTypeChangeConfirmationDialog: React.FC<
  CustomerTypeChangeConfirmationDialogProps
> = ({ isOpen, onConfirm, onCancel, currentType, newType }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      title="Change Customer Type?"
      size="lg"
      style="default"
      closeOnOutsideClick={false}
      hideFooter={true}
    >
      <div className="space-y-6">
        <p className="text-chariot-text-primary text-sm">
          Changing from <strong>{currentType || 'None'}</strong> to{' '}
          <strong>{newType}</strong> will clear all your current settings
          including:
        </p>
        <ul className="text-chariot-text-primary list-disc space-y-1 pl-6 text-sm">
          <li>Attack surface selections</li>
          <li>Period of performance dates</li>
          <li>Subscription pricing settings</li>
          <li>Advanced feature flags</li>
          <li>Team member lists</li>
        </ul>
        <p className="text-chariot-text-primary mb-6 text-sm font-medium">
          Are you sure you want to continue?
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="border-chariot-stroke text-chariot-text-secondary hover:bg-chariot-background-secondary rounded border px-4 py-2 text-sm transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="bg-chariot-brand-primary hover:bg-chariot-brand-primary/90 rounded px-4 py-2 text-sm text-white transition-colors"
          >
            Change Type
          </button>
        </div>
      </div>
    </Modal>
  );
};
